import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { MonitorWebService } from './monitor.web.service';
import { DeviceFilter } from 'DiscoveryEngine.TS/Core';
import { DisplayDeviceListDto, GetMonitorDeviceStatesResultDto } from 'UvExplorerServer.Dtos.TS/Session';
import {
	DisplayMonitorPolicyListDto, GetAgentMonitorPoliciesResultDto, GetMonitorStateResultDto,
	GetDeviceStateResultDto, GetMapDeviceStateResultDto, InfoSetView
} from 'UvExplorerServer.Dtos.TS/Session';
import { MessageService } from 'base';
import { UpdateResultDto, AgentMonitorPolicyDto } from 'UvExplorerServer.Dtos.TS';
import { List } from "DiscoveryEngine.TS/Utils";
import { MonitorPolicy } from 'DiscoveryEngine.TS/Monitors';


export class StateColors {
	public backColor: string;
	public backColor2: string;
	public foreColor: string;

	constructor() {
		this.backColor = "";
		this.backColor2 = "";
		this.foreColor = "";
	}
}


@Injectable()
export class MonitorService implements OnDestroy {

	constructor(private monWebService: MonitorWebService,
		private messageService: MessageService) {

		return;
	}

	public ngOnDestroy(): void {
		return;
	}

	public addDevicesToAgentMonitorNetwork(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		deviceGuids: string[]): Observable<boolean> {

		let subject = new Subject<boolean>();

		this.messageService.startWork();
		this.monWebService.addDevicesToAgentMonitorNetwork(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, deviceGuids).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public removeDevicesFromAgentMonitorNetwork(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		deviceGuids: string[]): Observable<boolean> {

		let subject = new Subject<boolean>();

		this.messageService.startWork();
		this.monWebService.removeDevicesFromAgentMonitorNetwork(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, deviceGuids).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public updateDevicesInAgentMonitorNetwork(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		deviceGuids: string[]): Observable<boolean> {

		let subject = new Subject<boolean>();

		this.messageService.startWork();
		this.monWebService.updateDevicesInAgentMonitorNetwork(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, deviceGuids).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getAgentMonitorPolicies(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, monitorPolicyGuids: List<string>,
		includeMonPolicies: boolean, includeMonPolicyStates: boolean, showBusy: boolean)
		: Observable<GetAgentMonitorPoliciesResultDto> {

		let subject = new Subject<GetAgentMonitorPoliciesResultDto>();

		if (showBusy) {
			this.messageService.startWork();
		}
		this.monWebService.getAgentMonitorPolicies(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, monitorPolicyGuids, includeMonPolicies,
			includeMonPolicyStates).subscribe(
				(result) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					subject.next(result);
				},
				(error) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public createAgentMonitorPolicy(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		monitorType: string): Observable<UpdateResultDto> {

		let subject = new Subject<UpdateResultDto>();

		this.messageService.startWork();
		this.monWebService.createAgentMonitorPolicy(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, monitorType).subscribe(
				(result: UpdateResultDto) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public deleteAgentMonitorPolicy(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		policyGuid: string): Observable<boolean> {

		let subject = new Subject<boolean>();

		this.messageService.startWork();
		this.monWebService.deleteAgentMonitorPolicy(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, policyGuid).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public enableAgentMonitorPolicy(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		policyGuid: string, enabled: boolean): Observable<UpdateResultDto> {

		let subject = new Subject<UpdateResultDto>();

		this.messageService.startWork();
		this.monWebService.enableAgentMonitorPolicy(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, policyGuid, enabled).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public updateAgentMonitorPolicy(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, policy: AgentMonitorPolicyDto)
		: Observable<UpdateResultDto> {

		let subject = new Subject<UpdateResultDto>();

		this.messageService.startWork();
		this.monWebService.updateAgentMonitorPolicy(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, policy).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getMonitorState(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, policy: MonitorPolicy, showBusy: boolean)
		: Observable<GetMonitorStateResultDto> {

		let subject = new Subject<GetMonitorStateResultDto>();

		if (showBusy) {
			this.messageService.startWork();
		}
		this.monWebService.getMonitorState(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, policy).subscribe(
				(result) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					subject.next(result);
				},
				(error) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getStateColors(monState: string): StateColors {

		const Black = "#000000";
		const White = "#FFFFFF";
		const PowderBlue = "B0E0E6";
		const Lime = "#00FF00";
		const Red = "#FF0000";
		const Gray = "#808080";
		const Yellow = "#FFFF00";
		const Blue = "#0000FF";
		const Purple = "#800080";

		let colors = new StateColors();
		colors.backColor = PowderBlue;
		colors.backColor2 = PowderBlue;
		colors.foreColor = White;

		switch (monState.toLowerCase()) {
			case "up":
				colors.backColor = Lime;
				colors.backColor2 = White;
				colors.foreColor = Black;				
				break;
			case "down":
				colors.backColor = Red;
				colors.backColor2 = White;
				colors.foreColor = White;
				break;
			case "nodata":
				colors.backColor = Gray;
				colors.backColor2 = White;
				colors.foreColor = White;
				break;
			case "warning":
				colors.backColor = Yellow;
				colors.backColor2 = White;
				colors.foreColor = Black;
				break;
			case "unknown":
				colors.backColor = Blue;
				colors.backColor2 = White;
				colors.foreColor = White;
				break;
			case "paused":
				colors.backColor = Purple;
				colors.backColor2 = White;
				colors.foreColor = White;
				break;
			default:
				console.assert(false);
				break;
		}

		return colors;
	}

	public getMonitorDeviceList(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, showBusy: boolean)
		: Observable<DisplayDeviceListDto> {

		let subject = new Subject<DisplayDeviceListDto>();

		if (showBusy) {
			this.messageService.startWork();
		}
		this.monWebService.getMonitorDeviceList(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid).subscribe(
				(result: DisplayDeviceListDto) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					subject.next(result);
				},
				(error) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getDeviceState(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, deviceGuid: string, showBusy: boolean)
		: Observable<GetDeviceStateResultDto> {

		let subject = new Subject<GetDeviceStateResultDto>();

		if (showBusy) {
			this.messageService.startWork();
		}
		this.monWebService.getDeviceState(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, deviceGuid).subscribe(
				(result) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					subject.next(result);
				},
				(error) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getMonitorDeviceStates(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, policy: MonitorPolicy, showBusy: boolean)
		: Observable<GetMonitorDeviceStatesResultDto> {

		let subject = new Subject<GetMonitorDeviceStatesResultDto>();

		if (showBusy) {
			this.messageService.startWork();
		}
		this.monWebService.getMonitorDeviceStates(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, policy).subscribe(
				(result) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					subject.next(result);
				},
				(error) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getMapDeviceState(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string, deviceGuids: string[], showBusy: boolean)
		: Observable<GetMapDeviceStateResultDto> {

		let subject = new Subject<GetMapDeviceStateResultDto>();

		if (showBusy) {
			this.messageService.startWork();
		}
		this.monWebService.getMapDeviceState(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, deviceGuids).subscribe(
				(result) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					subject.next(result);
				},
				(error) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public clearMonitorHistory(sessionGuid: string, netViewGuid: string,
		agentGuid: string, schedDiscGuid: string, schedDiscRsltGuid: string,
		policyGuid: string, deviceGuid: string): Observable<boolean> {

		let subject = new Subject<boolean>();

		this.messageService.startWork();
		this.monWebService.clearMonitorHistory(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, policyGuid, deviceGuid).subscribe(
				(result) => {
					this.messageService.endWork();
					subject.next(result);
				},
				(error) => {
					this.messageService.endWork();
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

	public getMonitorHistory(sessionGuid: string, netViewGuid: string, agentGuid: string,
		schedDiscGuid: string, schedDiscRsltGuid: string,
		monitorType: string, policyGuid: string, deviceGuid: string, showBusy: boolean)
		: Observable<InfoSetView> {

		let subject = new Subject<InfoSetView>();

		if (showBusy) {
			this.messageService.startWork();
		}
		this.monWebService.getMonitorHistory(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, monitorType, policyGuid, deviceGuid).subscribe(
				(result) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					subject.next(result);
				},
				(error) => {
					if (showBusy) {
						this.messageService.endWork();
					}
					console.log(error);
					subject.error(error);
				});

		return subject.asObservable();
	}

}
